module.exports = __webpack_public_path__ + "img/example_2.0d82cd43.png";